export default "__VITE_ASSET__CrRTCilA__"